function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.65 6.994c.118.069.27 0 .29-.137a6 6 0 0 0-9.65-5.572.193.193 0 0 0 .025.32L6.38 2.797a.207.207 0 0 0 .189.008 3.5 3.5 0 0 1 4.913 2.836.207.207 0 0 0 .101.16l2.066 1.193zm-9.223-.706c.056.032.093.09.1.154a3.5 3.5 0 0 0 4.827 2.786.207.207 0 0 1 .184.01l2.086 1.205c.12.07.134.236.024.32a6 6 0 0 1-9.598-5.54.193.193 0 0 1 .29-.139l2.087 1.205z",
  fill: "#1063CD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.336 2.234a.2.2 0 0 1 .328 0L6.78 6.685A.2.2 0 0 1 6.616 7H.384a.2.2 0 0 1-.164-.315l3.116-4.45zm9.328 7.532a.2.2 0 0 1-.328 0L9.22 5.315A.2.2 0 0 1 9.384 5h6.232a.2.2 0 0 1 .164.315l-3.116 4.45z",
  fill: "#1063CD"
});

const SvgRefresh = props => React.createElement("svg", _extends({
  viewBox: "0 0 16 12",
  fill: "none"
}, props), _ref, _ref2);

export default SvgRefresh;